angular.module("ainapp")
    .controller("documentsByJobNoController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Documents By Job";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $scope.View = 0;
                $scope.FolderName = "";
                $scope.FileName = {
                    FileName: ""
                };
                $scope.SelectedFolder = {};
                $scope.Folders = [];

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.CostCentersByParentName("Job No").then(function (response) {
                    $scope.Folders = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }
            $scope.Init();


            $scope.resetView = function () {
                $scope.View = 0;
            }

            $scope.getFiles = function (data) {

                $scope.View = 1;
                $scope.SelectedFolder = data;
                $scope.Files = [];
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.VoucherDocsByJobno(data.Name).then(function (response) {
                    $scope.Files = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }



   }]);
